import React, { Fragment } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import type { Headline as HeadlineType } from '../types/form';

type Props = {
  field: HeadlineType;
};

function Headline({ field }: Props) {
  return (
    <Fragment key={field.key}>
      <Grid item xs={field.xsWidth != null ? field.xsWidth : 12}>
        <Typography fontSize='1rem' mt={1} mb={0}>
          {field.label}
        </Typography>
      </Grid>
    </Fragment>
  );
}

export default Headline;
